import React from 'react';
import { ShowMoreButtonContainer } from './ShowMoreButton.styled';

export interface ShowMoreButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export function ShowMoreButton({
  children,
  onClick,
  disabled = false,
  className,
}: ShowMoreButtonProps) {
  return (
    <ShowMoreButtonContainer
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {children}
    </ShowMoreButtonContainer>
  );
}
